import DPDropDown from "framework/components/DPDropDown"
import React, { useState } from "react"
import { CardText, Col, Row, Alert } from "reactstrap"

import DPTextBox from "../../../framework/components/DPTextBox"


const SalesExecutiveMasterTab2 = ({
  address1,
  address1onChange,
  address2,
  address2onChange,
  address3,
  address3onChange,
  address4,
  address4onChange,
  AreaValue,
  AreaonChange,
  mobi1,
  mobi1onChange,
  mobi2,
  mobi2onChange,
  tele1,
  tele1onChange,
  tele2,
  tele2onChange,
  email,
  emailonChange,
  fax,
  faxonChange,
  AlertColor,
  AlertMsg,
  show,
  disabled,
  ErrorMsg

}) => {

  const [optionGroup, setoptionGroup] = useState([]);

  //  api call to suplier area
  React.useEffect(async () => {
    const authToken = localStorage.getItem("authToken")
    var requestOptions = {
      method: 'GET',
      headers: {
        "Authorization": `Bearer ${authToken}`
      },
      redirect: 'follow'
    };

    const ApiURL = window.Links.ApiURL
    await fetch(`${ApiURL}SupplierArea/Select`, requestOptions)
      .then(response => response.json())
      .then(result => {
        setoptionGroup(result.data)
        // let dt = result.data
        // console.log(dt)

      })
      .catch(error => console.log('error', error));
  }, []);

  return (
    <React.Fragment>
      <div>
        <Row>
          <Col sm="12">
            <CardText className="mb-0">
              <Row>
                {show ? (
                  <Alert color={AlertColor} role="alert">
                    {AlertMsg}
                    <br />
                    <small>{ErrorMsg}</small>
                  </Alert>
                ) : null}
                <Col sm={12} md={7} className="mb-4-sm">

                  <DPTextBox
                    rowClass="mb-4-sm"
                    labelText="Address *"
                    textType="text"
                    placeholder="Address Line 1"
                    maxLength="50"
                    value={address1}
                    onChange={address1onChange}
                    disabled={disabled}
                  />
                  <DPTextBox
                    rowClass="mb-4-sm"
                    labelText="&nbsp;"
                    textType="text"
                    placeholder="Address Line 2"
                    maxLength="50"
                    value={address2}
                    onChange={address2onChange}
                    disabled={disabled}
                  />
                  <DPTextBox
                    rowClass="mb-7-sm"
                    labelText="&nbsp;"
                    textType="text"
                    placeholder="Address Line 3"
                    maxLength="50"
                    value={address3}
                    onChange={address3onChange}
                    disabled={disabled}
                  />
                  <DPTextBox
                    rowClass="mb-4-sm"
                    labelText="&nbsp;"
                    textType="text"
                    placeholder="Address Line 4"
                    maxLength="50"
                    value={address4}
                    onChange={address4onChange}
                    disabled={disabled}
                  />
                  <DPDropDown
                    labelText="Area *"
                    rowClass="mb-4-sm"
                    optionGroup={optionGroup}
                    selectedGroup={AreaValue}
                    onChange={AreaonChange}
                    disabled={disabled}
                  />

                  <DPTextBox
                    rowClass="mb-4-sm"
                    labelText="Mobile *"
                    placeholder="Mobile 1"
                    textType="tel"
                    maxLength="10"
                    value={mobi1}
                    onChange={mobi1onChange}
                    disabled={disabled}
                  />
                  <DPTextBox
                    rowClass="mb-4-sm"
                    labelText="&nbsp;"
                    placeholder="Mobile 2"
                    textType="tel"
                    maxLength="10"
                    value={mobi2}
                    onChange={mobi2onChange}
                    disabled={disabled}
                  />
                  <DPTextBox
                    rowClass="mb-4-sm"
                    labelText="Telephone"
                    placeholder="Telephone 1"
                    textType="tel"
                    maxLength="10"
                    mask="999-9999999"
                    value={tele1}
                    onChange={tele1onChange}
                    disabled={disabled}
                  />
                  <DPTextBox
                    rowClass="mb-4-sm"
                    labelText="&nbsp;"
                    placeholder="Telephone 2"
                    textType="tel"
                    maxLength="10"
                    mask="999-9999999"
                    value={tele2}
                    onChange={tele2onChange}
                    disabled={disabled}
                  />

                  <DPTextBox
                    rowClass="mb-4-sm"
                    labelText="Fax No"
                    textType="tel"
                    maxLength="10"
                    value={fax}
                    onChange={faxonChange}
                    disabled={disabled}
                  />
                  <DPTextBox
                    rowClass="mb-4-sm"
                    labelText="E-Mail"
                    textType="test"
                    maxLength="40"
                    value={email}
                    onChange={emailonChange}
                    disabled={disabled}
                  />

                </Col>

              </Row>
            </CardText>
          </Col>
        </Row>
      </div>
    </React.Fragment>
  )
}
export default SalesExecutiveMasterTab2
